import React from 'react';
import {Pressable} from 'react-native';
import SharedDialog from '~/components/shared/Dialogs/CancelRobTask';

export default function CancelRobTaskDialog(props) {
  return <SharedDialog {...props} PressableComponent={Pressable} />;
}
